import React, { useRef, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { MEDIA_URL } from './constants';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import GbonganAI from './components/GbonganAI';

import HomePage from './pages/HomePage';
import ArchivePage from './pages/ArchivePage';
import CategoryPage from './pages/CategoryPage';
import SubcategoryPage from './pages/SubcategoryPage';
import { NewsListPage, NewsDetailPage } from './pages/NewsPage';
import HistoryHeritagePage from './pages/HistoryHeritagePage';
import ContributePage from './pages/ContributePage';
import CreditsPage from './pages/CreditsPage';
import ChatroomPage from './pages/chatroom/ChatroomPage';
import ChatRegisterPage from './pages/chatroom/ChatRegisterPage';
import ChatLoginPage from './pages/chatroom/ChatLoginPage';
import SearchPage from './pages/SearchPage';

// Global audio – plays ambient music across ALL sections/routes
function GlobalAudio() {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const tryPlay = () => audio.play().catch(() => {});
    tryPlay();

    const resume = () => { if (audio.paused) audio.play().catch(() => {}); };
    document.addEventListener('click', resume, { once: true });
    document.addEventListener('touchstart', resume, { once: true });
    document.addEventListener('keydown', resume, { once: true });

    return () => {
      document.removeEventListener('click', resume);
      document.removeEventListener('touchstart', resume);
      document.removeEventListener('keydown', resume);
    };
  }, []);

  return <audio ref={audioRef} src={`${MEDIA_URL}/audios/gbongan_oriki.mp3`} loop style={{ display: 'none' }} />;
}

function App() {
  return (
    <Router>
      <GlobalAudio />
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/archive/:categorySlug" element={<CategoryPage />} />
            <Route path="/archive/:categorySlug/:subcategorySlug" element={<SubcategoryPage />} />
            <Route path="/archive/:categorySlug/:subcategorySlug/person/:personId" element={<SubcategoryPage />} />
            <Route path="/news" element={<NewsListPage />} />
            <Route path="/news/:id" element={<NewsDetailPage />} />
            <Route path="/history-heritage" element={<HistoryHeritagePage />} />
            <Route path="/history-heritage/:section" element={<HistoryHeritagePage />} />
            <Route path="/contribute" element={<ContributePage />} />
            <Route path="/contribute/:type" element={<ContributePage />} />
            <Route path="/credits" element={<CreditsPage />} />
            <Route path="/chatroom" element={<ChatroomPage />} />
            <Route path="/chatroom/register" element={<ChatRegisterPage />} />
            <Route path="/chatroom/login" element={<ChatLoginPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="*" element={
              <div className="max-w-xl mx-auto px-4 py-24 text-center">
                <p className="text-6xl mb-4">🏛️</p>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h2>
                <p className="text-gray-600 mb-6">The page you're looking for doesn't exist in our archive.</p>
                <a href="/" className="bg-emerald-700 text-white px-6 py-2.5 rounded-xl hover:bg-emerald-800 transition font-medium">Go Home</a>
              </div>
            } />
          </Routes>
        </main>
        <Footer />
        {/* Gbongan AI Chatbot – visible on all pages */}
        <GbonganAI />
      </div>
    </Router>
  );
}

export default App;
